import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Panel} from "primereact/panel";
import {Password} from "primereact/password";
import {KeyboardEvent, useState} from "react";

function Credentials({
                         isLoading,
                         onLoginClick,
                     }: {
    isLoading: boolean;
    onLoginClick(username: string, password: string): void;
}) {
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");


    function handleKeyDown(e: KeyboardEvent<HTMLInputElement>): void {
        if (e.key === "Enter") {
            onLoginClick(username, password);
        }
    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                padding: "2rem",
                boxSizing: "border-box",
            }}
        >
            <Panel header="Login">
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5rem",
                    }}
                >
                    <div>
                        <span className="p-float-label mt-2">
                          <InputText
                              id="name"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              style={{width: "100%"}}
                          />
                          <label htmlFor="name">Benutzername</label>
                        </span>
                    </div>

                    <div>
                        <span className="p-float-label">
                          <Password
                              id="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              feedback={false}
                              toggleMask
                              onKeyDown={handleKeyDown}
                              style={{width: "100%"}}
                          />
                          <label htmlFor="password">Passwort</label>
                        </span>
                    </div>

                    <Button
                        loading={isLoading}
                        onClick={() => onLoginClick(username, password)}
                        label="Login"
                    />
                </div>
            </Panel>
        </div>
    );
}

export default Credentials;
